import { combineReducers } from "redux";
import { awbReducer } from "./awb";
import { companyInfoReducer } from "./companyInfo";
import { configsReducer } from "./configs";

export default combineReducers({
  awbReducer,
  companyInfoReducer,
  configsReducer,
});
